import { useOutletContext } from 'react-router-dom'
import { type CompensacaoManual } from '@/service/api'

export function useCompensacaoManualOutletContext() {
    return useOutletContext<{
        data: Map<number, CompensacaoManual>
        competencia: string
    }>()
}
